import { getSecondaryForDemographic } from '../app/selectors'
import {
  AREA_FLAGS,
  SCHOOL_AGE_FLAGS,
  SCHOOL_TYPE_FLAGS
} from '../app/constants/flags'

const FLAG_GROUPS = {
  area: AREA_FLAGS,
  age: SCHOOL_AGE_FLAGS,
  type: SCHOOL_TYPE_FLAGS
}

/**
 * Returns the count of active filters based on the filter array
 * @param {*} filters
 */
export const getActiveFilterCount = filters => {
  // "sort" doesn't count as an active filter because it's tied to "limit"
  const validFilters = filters.filter(f => f[0] !== 'sort')
  if (!validFilters.length) return 0

  // get the number of flag filters
  const flagFilters = validFilters
    .filter(f => f[0] === 'neq')
    .map(f => f[1])

  // a copy of the FLAG_GROUPS object, with the `neq` filter ids removed from each group, leaving behind active flags
  const activeFilterGroups = flagFilters.reduce(
    (result, filterId) => {
      const filterGroupId = Object.keys(FLAG_GROUPS).find(key =>
        FLAG_GROUPS[key].includes(filterId)
      )
      if (!filterGroupId) return result
      if (result.indexOf(filterGroupId) === -1)
        result.push(filterGroupId)
      return result
    },
    []
  )

  // counts all of the active filters in the `activeFilterGroups` object
  const flagFilterCount = activeFilterGroups.length

  // get the number of non-flag filters
  const nonFlagFilterCount = validFilters.filter(
    f => f[0] !== 'neq'
  ).length

  return flagFilterCount + nonFlagFilterCount
}

/**
 * Adds a demographic to the current range and sort filters
 */
export const getFiltersForDemographic = (
  filters,
  demographic
) => {
  return filters.map(f => {
    // no demographic for non-range and non-sort filters
    if (f[0] !== 'range' && f[0] !== 'sort') return f
    // for SES, if no demographic specific SES, use all_ses
    if (f[1] === 'ses') {
      const secondaryMetrics = getSecondaryForDemographic(
        demographic
      )
      const sesDem =
        secondaryMetrics.indexOf('ses') > -1
          ? demographic
          : 'all'
      return [f[0], sesDem + '_' + f[1], f[2]]
    }
    // add demographic to metric
    return [f[0], demographic + '_' + f[1], f[2]]
  })
}

/**
 * Removes any filter rules that do not apply to the provided region
 * (e.g. removes "frl" from if region is non-schools, or "ses" from schools)
 */
export const removeIrrelevantFilters = (filters, region) => {
  return region === 'schools'
    ? filters.filter(f => f[1] !== 'ses')
    : filters.filter(f => f[1] !== 'frl' && f[0] !== 'contains')
}

/**
 * Returns the search indicies for the current region
 * @param {*} region
 */
export const getIndiciesForSearch = region => {
  switch (region) {
    case 'states':
      return []
    case 'counties':
      return ['states']
    case 'districts':
      return ['states']
    default:
      return ['states', 'districts']
  }
}
